import {defineSlotRecipe} from '@chakra-ui/react3'

const quickViewRecipe = defineSlotRecipe({
    slots: ['footerContent', 'colorSwatches', 'availability', 'standaloneAvailability'],
    base: {
        footerContent: {
            display: {base: 'flex', xs: 'contents'},
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        },
        colorSwatches: {
            position: 'relative'
        },
        availability: {
            position: 'absolute',
            insetBlockStart: 0,
            insetInlineEnd: 0
        },
        standaloneAvailability: {
            alignSelf: 'flex-start'
        }
    }
})

export default quickViewRecipe
